import api from '../api';

const listSdgTargets = query => api.get('/api/sdg-targets/', { params: query });

export default {
  listSdgTargets,
};
